module.exports = "<prg-notification-parameters></prg-notification-parameters>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/push-notification/push-notification.component.html
// module id = 1587
// module chunks = 2